import React, { Component } from 'react';

import 'assets/css/components/site-nav.css';

import {
  NavLink,
} from "react-router-dom";

class SiteNav extends Component {
  render() {
    return (
      <nav className={`site-nav${this.props.isPhone === 'true' ? ' phone-only' : ' hide-phone'} ${this.props.navActive}`}>
        <div className="site-nav__container">
          <NavLink to="/" className="site-nav__link phone-only">Home</NavLink>
          <NavLink to="/work" className="site-nav__link">Portfolio</NavLink>
          <NavLink to="/resume" className="site-nav__link">Credentials</NavLink>
          {/* <NavLink to="/contact" className="site-nav__link">Get In Touch</NavLink> */}
        </div>
      </nav>
    );
  }
}

export default SiteNav;



// WEBPACK FOOTER //
// ./src/Components/SiteNav.js